import { activityListResx } from "~/resxDist/activityListResx";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { commonResx } from "~/resxDist/commonResx";
import { messageBoardResx } from "~/resxDist/messageBoardResx";
import { icon } from "~/sharedComponents/icons";
import { createButton, ViewProps } from "../Button";
import { ButtonFlag, ButtonVariants } from "../Enums";

const transparentBorderlessIcon = [ButtonFlag.With_icon];

const createButtonWithIcon = (displayName: string, props?: Partial<ViewProps>) =>
    createButton(displayName, {
        ...props,
        variant: ButtonVariants.Ghost,
        flags: transparentBorderlessIcon.concat((props || {}).flags || []),
        showTooltip: true,
    });

/**
 * Borderless transparent button with icon.
 * By default, highlighted on hover or when active.
 */
export const ButtonIcon = createButtonWithIcon("ButtonIcon");

export const ButtonCross = createButtonWithIcon("ButtonCross", {
    iconName: icon.cross,
});

export const ButtonTrash = createButtonWithIcon("ButtonTrash", {
    iconName: icon.delete,
});

export const ButtonDots = createButtonWithIcon("ButtonDots", {
    iconName: icon.more,
    title: commonResx.MoreActions,
});

export const ButtonHoursDistribution = createButtonWithIcon("ButtonHoursDistribution", {
    iconName: icon.arrows_sync,
    title: commonResx.MoreActions,
});

export const CreateSnapshotButton = createButtonWithIcon("CreateSnapshotButton", {
    iconName: icon.plus,
    title: activityListResx.create_snapshot,
});

export const ButtonFilter = createButtonWithIcon("ButtonFilter", {
    iconName: icon.filter,
    title: commonResx.filters,
});

export const ButtonRequest = createButtonWithIcon("ButtonRequest", {
    iconName: icon.approval_requests,
    title: messageBoardResx.RequestApprovalLabel,
});

export const ButtonClose = createButtonWithIcon("ButtonCrossBlack", {
    iconName: icon.cross,
    title: commonClientResx.Close,
});

export const ButtonPlus = createButtonWithIcon("ButtonPlus", {
    iconName: icon.plus,
});

export const ButtonMention = createButtonWithIcon("ButtonMention", {
    iconName: icon.mention,
});

export const ButtonAttachment = createButtonWithIcon("ButtonAttachment", {
    iconName: icon.attachment,
    title: commonClientResx.Attach,
});

export const ButtonPlane = createButtonWithIcon("ButtonPlane", {
    iconName: icon.post,
});

export const ButtonWorkflowTypeNotSet = createButtonWithIcon("ButtonWorkflowTypeNotSet", {
    iconName: icon.file_gear,
});

export const ButtonNullify = createButtonWithIcon("ButtonNullify", {
    iconName: icon.eraser,
});

export const ButtonMenu = createButtonWithIcon("ButtonMenu", {
    iconName: icon.more,
});

export const ButtonHideEye = createButtonWithIcon("ButtonHideEye", {
    iconName: icon.eye_hide,
});

export const ButtonBatchStart = createButtonWithIcon("ButtonBatchStart", {
    iconName: icon.batch,
    title: commonClientResx.selection_mode_text,
});
